import { Figure, Svg, Group, Line, Text, Circle, Label } from './Compas.style'
import { motion } from 'framer-motion'
import { iso_free, iso_isrotating, northDegree } from 'state/store.global'
import { useAtom } from 'jotai'
import { useEffect } from 'react'
import { getFocus, useGet } from 'state/jotai'
import { _bootstrap } from 'state/store.bootstrap'
import { useBreak } from 'hooks/useBreak'

export const Compas = ({ frame, cfg, label, percent, pin }) => {

  const [rmode] = useAtom(iso_free)
  const setNorthDegree = useAtom(northDegree)[1]
  const isrotate = useGet(iso_isrotating);
  const projectType    = getFocus(_bootstrap, 'type')
  const isMobile    = useBreak('md_dn')
  const init = cfg?.SLIDER_COMPASS?.[0] ?? 0
  const max = cfg?.LAST_IMAGE
  const min = cfg?.FIRST_IMAGE

  const inc = frame - min

  const degr = init + 360 * (inc / (max - min))

  useEffect(() => {
    setNorthDegree(Math?.round(degr))
  }, [degr])

  const move = (cx = '', cy = '', dir = '-') => ({
    transform: `rotate(${dir}${degr} ${cx} ${cy})`
  })
  
  const animation = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.5, ease: 'linear' },
  }

  const props = { projectType, rmode, isrotate, pin}
  if (!isNaN(degr)) return (
    percent == 100 &&
    <>
      <Figure { ...props } as={motion.div} {...animation} isMobile={isMobile}> 
      <Label { ...props }>
        { !isMobile &&  <span className='paragraph1-regular'> {label}</span>}
         
        </Label>
        <svg viewBox='0 0 1000 1000' fill={projectType === "mono" ? "#000" : pin > 0 ? '#000' : '#000'} >
          <g {...move(500, 500, '+')}>
            <path d="M 802.16481,194.87591 C 720.75555,114.9932 610.82588,70.437738 496.55523,71.015773 382.28751,71.590886 273.04153,117.24919 192.84979,197.94727 112.6589,278.64448 68.092084,387.77012 68.953654,501.31721 69.815223,614.86431 116.03462,723.53232 197.44395,803.41495 278.85417,883.29844 388.78463,927.85194 503.05236,927.27506 617.32302,926.70108 726.56809,881.04078 806.75896,800.34358 886.9507,719.64552 931.51841,610.52186 930.65393,496.97364 929.79526,383.4254 883.575,274.75942 802.16481,194.87591 Z M 154.2496,846.88202 C 61.210186,755.58743 8.3882072,631.39591 7.4035547,501.62747 6.4189004,371.85902 57.352242,247.14453 148.99913,154.91897 240.64601,62.693433 365.49755,10.51317 496.0923,9.8531751 626.6842,9.1960257 752.31976,60.114213 845.35915,151.40884 938.39861,242.70335 991.21881,366.89433 992.20634,496.66337 993.18813,626.4324 942.25651,751.14633 850.60962,843.37188 758.96274,935.5974 634.10949,987.77826 503.5176,988.43767 372.9228,989.09423 247.28898,938.17659 154.2496,846.88202 Z M 363.62037,709.72557 c -15.79299,15.89271 -40.9333,18.58929 -59.79772,6.24908 -18.86211,-12.06953 -26.65993,-36.08666 -18.38464,-56.94141 l 168.139,-426.58458 c 7.47844,-18.1482 24.66327,-29.99432 44.11308,-29.95685 19.4483,-0.23296 36.809,11.43931 44.29068,29.51214 l 174.60131,424.85748 c 7.20429,17.53158 3.14118,37.69186 -10.22027,51.13767 -2.15975,2.17338 -4.5919,4.34834 -7.30157,5.98201 -18.67542,12.52979 -43.85384,10.08767 -60.02302,-5.7783 l -94.82859,-93.05002 -43.85048,-43.02848 -43.19501,43.46773 z m 3.79788,-90.97772 89.08922,-89.65173 c 23.89226,-24.0431 62.78971,-24.23911 87.04502,-0.43875 l 90.44314,88.7476 L 498.33144,287.09583 367.55301,618.61224 Z" />
          </g>
        </svg>
      </Figure>
    </>
  )
  return null

}